
export interface IWebSocketContract {
    id: string;
    message: string;
    room: string;
}
